module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['instagram-feed', 'instagram-feed--' + _vm.mode, {
      'instagram-feed--error': _vm.error
    }]
  }, [(!_vm.isLoading) ? _c('div', {
    staticClass: "instagram-feed__medias"
  }, [_vm._l((_vm.medias), function(media, index) {
    return _c('div', {
      class: ['instagram-feed__media', {
        'instagram-feed__media--active': _vm.mode == 'slider' && _vm.sliderIndex == index
      }]
    }, [(_vm.mode == 'slider') ? _c('div', {
      staticClass: "instagram-feed__blur",
      style: ({
        'background-image': 'url(' + media.images[_vm.mediaResolution].url + ')'
      })
    }) : _vm._e(), _vm._v(" "), (media.type == 'image' || _vm.mode !== 'slider') ? _c('div', {
      staticClass: "instagram-feed__image",
      style: ({
        'background-image': 'url(' + media.images[_vm.mediaResolution].url + ')'
      })
    }) : _vm._e(), _vm._v(" "), (media.type == 'video' && _vm.mode === 'slider') ? _c('video', {
      staticClass: "instagram-feed__video",
      attrs: {
        "poster": media.images.standard_resolution.url,
        "autoplay": "",
        "muted": "",
        "onloadedmetadata": "this.muted = true",
        "loop": ""
      }
    }, [_c('source', {
      attrs: {
        "src": media.videos.low_resolution.url,
        "type": "video/mp4"
      }
    }), _vm._v("\n        Your browser does not support the video tag.\n      ")]) : _vm._e(), _vm._v(" "), (_vm.mode !== 'slider') ? _c('a', {
      attrs: {
        "href": media.link,
        "target": "_blank"
      }
    }) : _vm._e()])
  }), _vm._v(" "), (_vm.mode !== 'slider' && _vm.loadMoreEnable) ? _c('div', {
    staticClass: "load-more"
  }, [_c('button', {
    staticClass: "load-more-button",
    on: {
      "click": _vm.loadMoreMedias
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t("instagramFeedLoadMore", _vm.lang)) + "\n      ")])]) : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.isLoading && !_vm.error) ? _c('spinner') : _vm._e(), _vm._v(" "), (_vm.error) ? _c('div', {
    staticClass: "instagram-feed__error-message"
  }, [_vm._v("\n    " + _vm._s(_vm.$t("instagramFeedError", _vm.lang)) + "\n  ")]) : _vm._e(), _vm._v(" "), (_vm.mode == 'slider' && !_vm.isLoading) ? [_c('div', {
    staticClass: "instagram-feed__arrow instagram-feed__arrow--left",
    on: {
      "click": _vm.previousMedia
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "instagram-feed__arrow instagram-feed__arrow--right",
    on: {
      "click": _vm.nextMedia
    }
  })] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7d51891a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/InstagramFeed.vue
// module id = 175
// module chunks = 0